"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { useLockBodyScroll } from "~/lib/hooks/useLockBodyScroll";

interface IssuuState {
	isOpen: boolean;
	open: (open: boolean) => void;
	close: () => void;
	toggle: () => void;
}

const useIssuuStore = create<IssuuState>()((set) => ({
	isOpen: false,
	open: (open) => set({ isOpen: open }),
	close: () => set({ isOpen: false }),
	toggle: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export const useIssuuModal = () => {
	const { isOpen, open: openModal, close: closeModal, toggle: toggleModal } = useIssuuStore();

	// handle route changes
	const [currentPath, setCurrentPath] = useState<string>("");
	const path = usePathname();
	useEffect(() => {
		if (currentPath !== path) {
			setCurrentPath(path);
			closeModal();
		}
	}, [path, currentPath, closeModal]);

	// locking scroll
	const { unlockBodyScroll, lockBodyScroll, toggleBodyScroll } = useLockBodyScroll();
	const open = () => {
		openModal(true);
		lockBodyScroll();
	};
	const close = () => {
		closeModal();
		unlockBodyScroll();
	};
	const toggle = () => {
		toggleModal();
		toggleBodyScroll();
	};

	return { isOpen, open, close, toggle };
};
